import { LOCALE } from "core/interfaces";

import { en } from "~/common/locales/en/index";
import { uk } from "~/common/locales/uk/index";

export default defineI18nConfig(() => ({
	legacy: false,
	messages: {
		[LOCALE.ENGLISH]: en,
		[LOCALE.UKRAINIAN]: uk
	}
}));
